// useUpdateNotes.ts
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

interface NoteUpdate {
  primaryKey: string
  sortKey: string
  itemId: any
  itemSortKey: any
  fieldName: string
  newValue: any[]
  orgId: any
  type: string
}

export const useUpdateNotes = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (updates: NoteUpdate[]) => {
      return axios.put(`${baseUrl}/aws/checklists/notes/add`, { updates })
    },
    onSuccess: (_, variables) => {
      const { orgId, type } = variables[0]
      queryClient.invalidateQueries({ queryKey: [type === 'optimization' ? 'optimizations' : 'tasks', orgId] })
    },
    onError: err => {
      console.error('Failed to update notes:', err)
    },
  })
}
